
import './App.css';
import Navbar from './Navbar'

function App() {
  return (
    <div>
     <Navbar/>
    </div>
  );
}

export default App;
